"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M12.5125 5.5c0 .8284-.6716 1.5-1.5 1.5s-1.5-.6716-1.5-1.5.6716-1.5 1.5-1.5 1.5.6716 1.5 1.5zm-.1885 5.7474a.7159.7159 0 0 0 .2176.1684l2.1403 1.0701.6385-1.2763-2.015-1.0074-1.6045-1.8335a2.1315 2.1315 0 0 0-2.7453-.406l-1.824 1.1398a.7124.7124 0 0 0-.277.3239l-1.0702 2.497 1.3113.5622.9823-2.2916.7909-.4944-.2608 4.2385-.8233 2.471-2.7545 3.443 1.3926 1.114 2.8537-3.5671a.8932.8932 0 0 0 .1498-.2751l.7456-2.238 1.1383 2.2758L12.3572 21l1.7208-.4691-1.0701-3.9239a.9247.9247 0 0 0-.0628-.164l-1.4572-2.9148.1891-3.0206.647.7398zm3.1256 1.4476 2.5443 8.3241 1.1475-.3507-2.5443-8.3242-1.1475.3508z"
  })];
};

exports.default = _default;